import React from "react";
import { Container, Col, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HeroSection } from "../../Components/HeroSection";
import Saly from "../../assets/images/Saly-45.png";

export const Home = () => {
  let dataArr = [
    { title: "AAPL", number: "141.66", quantity: "3.39", status: "profit" },
    { title: "SBUX", number: "78.11", quantity: "2.91", status: "profit" },
    { title: "FTSE", number: "7,208.81", quantity: "188.36", status: "profit" },
    {
      title: "BTC-USD",
      number: "21,069.24",
      quantity: "64.07",
      status: "lose",
    },
  ];

  let sectionArr = [
    {
      title: "Alternative Data Analytics",
      desc: "Empower investors with alternative data analytics and recommendation systems.",
    },
    {
      title: "Alpha Discovery",
      desc: "Research, innovete and implement alphas as well as commonly used indicators.",
    },
    {
      title: "Alpha Verification",
      desc: "Understand the various properties of alphas such as seasonal tendencies.",
    },
    {
      title: "Alpha Recommendation",
      desc: "Recommend specific insights/indicators to utilize depending on the current market cycle and regime through the use of data science and machine learning",
    },
  ];
  return (
    <>
      <HeroSection />
      <div className="px-3 px-sm-0">
        <Container>
          <Row className="shadow p-4 my-5 rounded-24">
            {dataArr.map((data, index) => {
              return (
                <Col key={index} xs="6" lg="3" className="mb-5 mb-lg-4">
                  <div className="text-center">
                    <h5 className="text-uppercase">{data.title}</h5>
                    <h3
                      className={
                        data.status === "lose" && data.quantity > 50
                          ? "text-danger"
                          : data.status === "profit" && data.quantity > 50
                          ? "text-success"
                          : ""
                      }
                    >
                      {data.number}
                    </h3>
                    <h6>
                      {data.status === "profit"
                        ? "+"
                        : data.status === "lose"
                        ? "-"
                        : ""}
                      {data.quantity}
                    </h6>
                  </div>
                </Col>
              );
            })}
          </Row>

          <Row className="justify-content-center pt-5">
            <Col className="col-lg-9">
              <section>
                <div className="text-center mb-5">
                  <h4 className="text-primary">Why Lumnis?</h4>
                  <h2 className="text-black mb-4">
                    Powered by Machine Learning and{" "}
                    <br className="d-none d-lg-block" /> Alternative Data
                  </h2>
                </div>
                <Row>
                  {sectionArr.map((item, index) => {
                    return (
                      <Col md="6" key={index} className="mb-5">
                        <div className="text-center">
                          <h4 className="text-black">{item.title}</h4>
                          <p>{item.desc}</p>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </section>
            </Col>
          </Row>

          <section className="my-5">
            <Row className="align-items-center">
              <Col lg="6">
                <div>
                  <h5 className="text-primary">Our platform</h5>
                  <h2 className="text-black">
                    Join The Machine Learning Revolution in Finance
                  </h2>
                  <p>
                    We do the heavy lifting of researching complex data sets
                    with statistical significance in forecasting the price of
                    crypto assets.
                  </p>
                  <p>
                    We then present these insights in an easily digestible
                    format, as well as the analysis that supports our
                    conclusions. Datasets include:
                  </p>
                  <Link to="/">
                    <Button variant="primary" className="btn-lg">
                      Get Started
                    </Button>
                  </Link>
                </div>
              </Col>
              <Col lg="6">
                <div className="d-flex justify-content-center align-items-center">
                  <img
                    src={Saly}
                    alt="Saly"
                    className="img-fluid obj-fit-cover obj-position-center mw-400"
                    width="100%"
                    height="auto"
                  />
                </div>
              </Col>
            </Row>
          </section>
        </Container>
      </div>
    </>
  );
};
